(function () {
    'use strict';

    angular
        .module('rms.common')
        .directive('listFilterSelectAll', listFilterSelectAll);

    function listFilterSelectAll() {
        return {
            restrict: 'E',
            scope: {
                flag: '='
            },
            templateUrl: 'common/components/select-all',
            controller: listFilterSelectAllCtrl,
            controllerAs: 'vm',
            bindToController: true
        };
    }

    function listFilterSelectAllCtrl(SELECT_CONSTANT, $scope, $timeout) {
        var vm = this;
        this.$onInit = function() {
            $scope.listFilterService = $scope.$parent.listFilterService;
            vm.constant = SELECT_CONSTANT;

            vm.toggleSelectAll = toggleSelectAll;
        }

        function toggleSelectAll() {
            $scope.listFilterService.toggleSelectAll();
        }
    }
})();